<template>
  <v-navigation-drawer
    :value="showDrawer"
    temporary
    fixed
    right
    width="500"
    :disable-route-watcher="true"
    stateless
  >
    <template v-slot:prepend>
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title ref="titolo" class="text-h6">{{drawerTitle}}</v-list-item-title>
          <v-list-item-subtitle>{{drawerSubtitle}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-divider></v-divider>
    <v-form ref="form" v-model="formFieldsValid" lazy-validation>
      <v-list dense>
        <v-list-item
          v-for="item in documentoItems"
          :key="item.label"
        >
          <v-list-item-content>
            <v-list-item-title>
              <component :is="'p' + item.type" :item="item" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-form>
    <template v-slot:append>
      <v-container fluid>
        <v-row align="center">
          <v-col class="d-flex justify-space-around" cols="12" sm="6" v-if="!readOnly">
            <v-badge bordered color="error" icon="mdi-lock" title="Verificare i dati inseriti" overlap :value="!formFieldsValid">
              <v-btn color="success mb-2" @click="onSalva" :disabled="!formFieldsValid">Salva</v-btn>
            </v-badge>
          </v-col>
          <v-col class="d-flex justify-space-around" cols="12" sm="6">
            <v-btn color="secondary mb-s" @click="onAnnulla" >{{annullaTitle}}</v-btn>
          </v-col>
        </v-row>
      </v-container>
      <dialog-conferma
        :show="dialogConferma"
        :title="titoloConferma"
        :message="messaggioConferma"
        @dialog-confirm="onConferma"
        @dialog-cancel="dialogConferma=false"
      />
    </template>
  </v-navigation-drawer>
</template>

<script>
import * as dot from 'dot-object'
import _ from 'lodash'
import configurazioni from '@/services/configurazioniService.js'
import clienti from '@/services/clientiService.js'
import DialogConferma from '@/components/dialogConferma'

import pTesto from '@/views/drawer/elementi/testo'
import pMultiselect from '@/views/drawer/elementi/multiselect'
import pData from '@/views/drawer/elementi/data'
import pProdotto from '@/views/drawer/elementi/prodotto'
import pClifor from '@/views/drawer/elementi/clifor'
import pDestinazioni from '@/views/drawer/elementi/destinazioni'

export default {
  components: {
    DialogConferma,
    pTesto,
    pMultiselect,
    pData,
    pProdotto,
    pClifor,
    pDestinazioni
  },
  data: (vm) => ({
    backoffice: null,
    show: false,
    locDocumento: null,
    formFieldsValid: true,
    dialogConferma: false,
    titoloConferma: '',
    messaggioConferma: '',
    onConferma: vm.modificaPrezzoAcquisto,
    updateTrigger: 1
  }),
  async mounted() {
    this.backoffice = await configurazioni.getConfigurazione('backoffice', 'pagine')
    this.locDocumento = this.$store.getters['documenti/documento'] || null
    if (this.nuovoCliforCreato) {
      this.locDocumento.appoggio = this.locDocumento.appoggio || {}
      this.locDocumento.anagrafica = this.locDocumento.anagrafica || {}
      if (this.locDocumento.appoggio.clienteVisibile) { // verificare tutto
        this.locDocumento.anagrafica.cliente = { codice: this.nuovoCliforCreato._id }
        this.locDocumento.appoggio.cliente = this.nuovoCliforCreato
      } else if (this.locDocumento.appoggio.fornitoreVisibile) {
        this.locDocumento.anagrafica.fornitore = { codice: this.nuovoCliforCreato._id }
        this.locDocumento.appoggio.fornitore = this.nuovoCliforCreato
      }
      this.updateTrigger++
      this.locDocumento.appoggio.clifor = {
        codice: this.nuovoCliforCreato.codice,
        descrizione: this.nuovoCliforCreato.ragioneSociale
      }
      await this.$nextTick()
      this.updateTrigger++
      this.$store.commit('clienti/SET_CLIFOR_CREATO', null)
    }  
  },
  watch: {
    documento(value) {
      this.locDocumento = value
    }
  },
  computed: {
    showDrawer() {
      return this.$store.getters.rightDrawer
    },
    readOnly() {
      return this.$store.getters.rightDrawerReadOnly
    },
    drawerTitle() {
      if (this.readOnly) {
        return 'Visualizza documento'
      } else {
        return this.locDocumento && this.locDocumento._id ? 'Modifica documento' : 'Nuovo documento'
      }
    },
    drawerSubtitle() {
      return this.updateTrigger ? _.get(this.locDocumento, 'tipoDocumento.descrizione', '') : ''
    },
    annullaTitle() {
      return this.readOnly ? 'Chiudi' : 'Annulla'
    },
    documento() {
      return this.$store.getters['documenti/documento'] || null // || { codice: '', descrizione: '' }
    },
    documentoItems() {
      if (!this.locDocumento || !this.backoffice || !this.updateTrigger) {
        return []
      }
      const vars = this.backoffice.documenti
      const items = []
      // item.subModel, --> usato per marchio, tipoItem tipoBene : Da categorie leggo codice, descrizione ma devo salvare solo descrizione o solo codice
      for (const item of vars) {
        items.push({value: dot.pick(item.valueField, this.locDocumento), ...item})
      }
      return items
    },
    nuovoArticoloCreato() {
      var na = this.$store.getters['documenti/articoloCreato'] || null
      return na
    },
    nuovoCliforCreato() {
      var na = this.$store.getters['clienti/cliforCreato'] || null
      return na
    }
  },
  methods: {
    async componentValueChange(data) {
      const { model, subModel, value, decimals } = data
      let tgt = {}
      if (subModel) {
        let vv = value[subModel]
        if (decimals >= 0) {s
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      } else {
        let vv = value
        if (decimals >= 0) {
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      }
      _.merge(this.locDocumento, tgt)
      await this.aggiornaCorrelati(data)
      this.$store.commit('documenti/SET_DOCUMENTO', this.locDocumento) // verificare se va fatta store_temp
    },
    async aggiornaCorrelati(data) {
      this.locDocumento.appoggio = this.locDocumento.appoggio || {}
      switch (data.model) {
         case 'tipoDocumento.codice':
          this.locDocumento.appoggio.tipoDocumento = data.value
          this.locDocumento.appoggio.clienteVisibile = data.value.visualizzaCliente
          this.locDocumento.appoggio.fornitoreVisibile = data.value.visualizzaFornitore
          this.locDocumento.appoggio.spedizioneVisibile = data.value.infoSpedizione
          this.locDocumento.appoggio.pagamentoVisibile = data.value.infoPagamento
          this.locDocumento.tipoDocumento = data.value
          // this.locDocumento.tipoDocumentoDescrizione = data.value.descrizione
          this.updateTrigger++
          break;
        case 'anagrafica.cliente':
        case 'anagrafica.fornitore':
          const clienteId = data.value.codice
          const clifor = await clienti.getCliente(clienteId)
          // this.locDocumento.appoggio.clifor = clifor
           _.set(this.locDocumento,'appoggio.clifor', clifor)
          _.set(this.locDocumento, 'pagamento.condizioni', _.get(clifor, 'amministrativi.pagamento.condizioni', ''))
           _.set(this.locDocumento, 'pagamento.dettaglio.modalita', _.get(clifor, 'amministrativi.pagamento.dettaglio.modalita', ''))
           const sede = clifor.recapiti.length > 0 ? clifor.recapiti.find(x => x.tipo.codice === 'principale') : {}
           _.set(this.locDocumento, 'spedizione.destinazione', sede)
           _.set(this.locDocumento, data.model + '.amministrativi', _.get(clifor, 'amministrativi', ''))
           _.set(this.locDocumento, data.model + '.fatturazione', _.get(clifor, 'fatturazione', ''))
           await this.$nextTick()
          this.updateTrigger++
          break;
        case 'spedizione.destinazione':
          _.set(this.locDocumento, 'spedizione.destinazione', data.value)
          break;
        default:
          break
      } 
    },
    modificaPrezzoAcquisto(unitario) {
      console.log('Modifica prezzo acquisto')
      if (unitario) {

      } else {

      }
    },
    modificaPrezzoVendita(unitario) {
      console.log('Modifica prezzo vendita')
      if (unitario) {

      } else {
        
      }
    },
    onAnnulla() {
      this.$refs.form.reset()
      this.$store.commit('SET_RIGHT_DRAWER', false)
      this.$store.commit('documenti/SET_REFRESH')
      this.$store.commit('documenti/CLEAR_DOCUMENTO')
    },
    onSalva() {
      const valid = this.$refs.form.validate()
      if (valid) {
        // TODO: eliminare i campi di appoggio creati per la gestione dell'interfaccia
        this.$store.commit('documenti/SET_DOCUMENTO', this.locDocumento)
        this.$store.commit('documenti/SET_DOCUMENTO_SAVED')
      }
    }
  }
}
</script>